import React from "react";
import ModalEditPaintPoint from "../../../company/profil/pitch/modal/modal-edit-pain-point";
import { IProps } from "../../../company/profil/pitch/modal/modal-edit-pain-point";
export default function ModalFundingRound(props: IProps) {
  return <ModalEditPaintPoint {...props} />;
}
